import React from 'react';
import { Home, Zap, BarChart as ChartBar, ArrowRight, Check } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FAQs from '../components/FAQs';
const FullHomePlan: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-wenergie-blue/10 via-sky-50 to-wenergie-orange/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              No solar? No problem.
            </h1>
            <p className="text-xl text-gray-700 mb-8">
              Access clean energy — no rooftop, no upfront cost.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center justify-center px-8 py-3 bg-wenergie-blue text-white rounded-full font-medium hover:bg-wenergie-blue/90 transition duration-300 shadow-lg"
            >
              Join the Network
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            ⚡️ Clean Power for Every Home — No Panels Needed
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
              <Home className="h-12 w-12 text-wenergie-blue mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Connect to the Wenergie Network</h3>
              <p className="text-gray-600">
                Tap into real-time clean energy, even if you can't install solar.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
              <ChartBar className="h-12 w-12 text-wenergie-orange mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Real-time Insights That Put you in Charge</h3>
              <p className="text-gray-600">
                See how your home uses electricity clearly, and in real time— no surprises at the end of the month.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
              <Zap className="h-12 w-12 text-wenergie-blue mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Earn for Every Clean kWh</h3>
              <p className="text-gray-600">
                Be rewarded just for shifting usage to when clean power is abundant.
              </p>
            </div>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <h3 className="text-xl font-bold text-gray-900 mb-4">No Upfront Investment</h3>
              <p className="text-gray-600 mb-6">
                Clean energy is no longer only for those who can afford solar panels or batteries.
              </p>
              <div className="flex items-center text-wenergie-blue">
                <Check className="h-5 w-5 mr-2" />
                <span>Start with zero installation costs</span>
              </div>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Setup is Easy</h3>
              <ol className="space-y-4">
                <li className="flex items-center">
                  <span className="w-8 h-8 rounded-full bg-wenergie-blue text-white flex items-center justify-center mr-3">1</span>
                  <span>Buy a ReDER Personal Energy Assistant</span>
                </li>
                <li className="flex items-center">
                  <span className="w-8 h-8 rounded-full bg-wenergie-blue text-white flex items-center justify-center mr-3">2</span>
                  <span>Download the Wenergie App</span>
                </li>
                <li className="flex items-center">
                  <span className="w-8 h-8 rounded-full bg-wenergie-blue text-white flex items-center justify-center mr-3">3</span>
                  <span>Connect in under a minute — and start earning</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <FAQs/>
      <Footer />
    </div>
  );
};

export default FullHomePlan;